export const INITIAL_MEDICAL_BREAKDOWN_SUMMARY = {
  totalMedicalBills: 0,
  totalIncludedInReduction: 0,
  totalSettledAmount: 0,
  totalMedicalShare: 0,
  remainingUnclaimed: 0,
};

export const buildMedicalBreakdownSummary = (settlementResponse) => ({
  totalMedicalBills: settlementResponse?.total_medical_bills || 0,
  totalIncludedInReduction: settlementResponse?.total_included_in_reduction || 0,
  totalSettledAmount: settlementResponse?.total_settled_amount || 0,
  totalMedicalShare: settlementResponse?.total_medical_share || 0,
  remainingUnclaimed: settlementResponse?.remaining_unclaimed || 0,
});
